import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { CancelShipmentFormModalContent } from "./CancelShipmentFormModalContent";

import type { PendingOffPlatformBooking } from "hooks";

interface Props {
  open: boolean;
  onClose: VoidFunction;
  onCancelShipment: VoidFunction;
  error: string | null;
  loading: boolean;
  selectedOption: string | null;
  onSelectedOptionChange: (option: string) => void;
  cancellationReason: string;
  onCancellationUpdate: (newValue: string) => void;
  shipment: CondensedShipment;
  onRecordOffPlatformBooking?: VoidFunction;
  pendingOffPlatformBooking: PendingOffPlatformBooking | null;
}

export function CancelShipmentForm(props: Props) {
  const {
    open,
    onClose,
    onCancelShipment,
    error,
    loading,
    selectedOption,
    onSelectedOptionChange,
    cancellationReason,
    onCancellationUpdate,
    shipment,
    onRecordOffPlatformBooking,
    pendingOffPlatformBooking,
  } = props;

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle component="div">
        <Typography variant="h4">Cancel Shipment</Typography>
      </DialogTitle>
      <DialogContent>
        <CancelShipmentFormModalContent
          selectedOption={selectedOption}
          onSelectedOptionChange={onSelectedOptionChange}
          cancellationReason={cancellationReason}
          onCancellationUpdate={onCancellationUpdate}
          loading={loading}
          error={error}
          shipment={shipment}
          onRecordOffPlatformBooking={onRecordOffPlatformBooking}
          pendingOffPlatformBooking={pendingOffPlatformBooking}
        />
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button autoFocus variant="contained" onClick={onClose}>
            Go Back
          </Button>
          <Button
            onClick={onCancelShipment}
            disabled={
              shipment.info.type !== "QUOTES_ONLY" && cancellationReason === ""
            }
            color="error"
          >
            {!error ? "Cancel Shipment" : "retry"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
